import React, { useEffect } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { isWhiteColor } from '../../../Utils/helper';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import { RelativeDiv } from './styled';
import {
  BannerSubTitle,
  BannerTitle,
  GridWrapper,
} from '../BannersGrid/styled';
import GridCarouselCard from './GridCarouselCard';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';

export default function BannerGridCarousel(props) {
  const { banner, type, parentIndex } = props;
  useEffect(() => {
    cardServedEvent(banner);
  }, []);
  return (
    <GridWrapper
      sectionBgColorEnd={banner?.sectionBgColorEnd}
      sectionBgColorStart={banner?.sectionBgColorStart}
      padding={
        !isWhiteColor(banner?.sectionBgColorStart, banner?.sectionBgColorEnd)
      }
    >
      {banner?.heading && type != 'bestSeller' ? (
        <BannerTitle subHeading={banner?.subHeading?.length}>
          <h2>{banner?.heading} </h2>
        </BannerTitle>
      ) : null}
      {banner?.subHeading && type != 'bestSeller' ? (
        <BannerSubTitle>
          <h2>{banner?.subHeading} </h2>
        </BannerSubTitle>
      ) : null}
      <RelativeDiv>
        <AnywhereHorizontalScroll
          firstElementId={`${banner?.itemName}first`}
          lastElementId={`${banner?.itemName}last`}
          leftArrow={<img src={images.arrowdownforward} alt="arrow Forward" />}
          rightArrow={<img src={images.arrowdownforward} alt="arrow Forward" />}
          scrolledWidth={420}
        >
          {banner?.items?.map((element, index) => {
            return (
              <GridCarouselCard
                parentIndex={parentIndex}
                sectionHeading={banner?.heading}
                sectionName={banner?.itemName}
                banner={banner}
                type={type}
                element={element}
                key={index}
                index={index}
                length={banner?.items?.length}
              />
            );
          })}
        </AnywhereHorizontalScroll>
      </RelativeDiv>
    </GridWrapper>
  );
}
